import { connect } from 'react-redux';
import {
  getFinishedProduct,
  confirmFinishedProduct,
  stornoFinishedProduct,
  setCancelSendToSap
} from '../../../store/actions/finishedProduct';
import FinishedProductConfirmation from './FinishedProductConfirmation';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({
  finishedProductReducer,
  tabsReducer,
  userReducer
}) => ({
  finishedProductReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getFinishedProduct,
  confirmFinishedProduct,
  stornoFinishedProduct,
  modalErrorOpen,
  setCancelSendToSap
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinishedProductConfirmation);
